<template>
  <div class="gestion-planes-container">
    <!-- Header Principal -->
    <div class="content-header mb-4">
      <div class="row">
        <div class="col-md-8">
          <h2 class="content-title">
            <i class="nc-icon nc-credit-card mr-2"></i>
            Biblioteca de Planes
          </h2>
          <p class="content-subtitle">
            Gestión completa de Familias, SubFamilias y Planes del sistema CentralGym
          </p>
        </div>
        <div class="col-md-4 text-right">
          <button class="btn btn-success btn-sm" @click="refreshAll">
            <i class="nc-icon nc-refresh-02 mr-1"></i>
            Actualizar Todo
          </button>
        </div>
      </div>
    </div>

    <!-- Navegación por Pestañas -->
    <div class="nav-tabs-container mb-4">
      <div class="nav-tabs-wrapper">
        <!-- Usando @click.prevent para evitar que los enlaces salten al tope de la página -->
        <ul class="nav nav-tabs nav-justified" role="tablist">
          <li class="nav-item">
            <a 
              class="nav-link" 
              :class="{ active: activeTab === 'familias' }"
              @click.prevent="setActiveTab('familias')"
              href="#"
            >
              <div class="tab-content-wrapper">
                <div class="tab-icon-text">
                  <i class="nc-icon nc-bullet-list-67"></i>
                  <span class="tab-text d-none d-sm-inline">Familias</span>
                  <span class="tab-text d-sm-none">Fam</span>
                </div>
                <div class="tab-badge" v-if="estadisticas.totalFamilias && estadisticas.totalFamilias > 0">
                  <span class="badge badge-primary">
                    {{ estadisticas.totalFamilias }}
                  </span>
                </div>
              </div>
              <!-- Indicador verde para pestaña activa -->
              <div v-if="activeTab === 'familias'" class="tab-active-indicator"></div>
            </a>
          </li>
          <li class="nav-item">
            <a 
              class="nav-link" 
              :class="{ active: activeTab === 'subfamilias' }"
              @click.prevent="setActiveTab('subfamilias')"
              href="#"
            >
              <div class="tab-content-wrapper">
                <div class="tab-icon-text">
                  <i class="nc-icon nc-tag-content"></i>
                  <span class="tab-text d-none d-sm-inline">SubFamilias</span>
                  <span class="tab-text d-sm-none">Sub</span>
                </div>
                <div class="tab-badge" v-if="estadisticas.totalSubFamilias && estadisticas.totalSubFamilias > 0">
                  <span class="badge badge-info">
                    {{ estadisticas.totalSubFamilias }}
                  </span>
                </div>
              </div>
              <!-- Indicador verde para pestaña activa -->
              <div v-if="activeTab === 'subfamilias'" class="tab-active-indicator"></div>
            </a>
          </li>
          <li class="nav-item">
            <a 
              class="nav-link" 
              :class="{ active: activeTab === 'planes' }"
              @click.prevent="setActiveTab('planes')"
              href="#"
            >
              <div class="tab-content-wrapper">
                <div class="tab-icon-text">
                  <i class="nc-icon nc-credit-card"></i>
                  <span class="tab-text d-none d-sm-inline">Planes</span>
                  <span class="tab-text d-sm-none">Pln</span>
                </div>
                <div class="tab-badge" v-if="estadisticas.totalPlanes && estadisticas.totalPlanes > 0">
                  <span class="badge badge-warning">
                    {{ estadisticas.totalPlanes }}
                  </span>
                </div>
              </div>
              <!-- Indicador verde para pestaña activa -->
              <div v-if="activeTab === 'planes'" class="tab-active-indicator"></div>
            </a>
          </li>

          <li class="nav-item">
            <a 
              class="nav-link" 
              :class="{ active: activeTab === 'estadisticas' }"
              @click.prevent="setActiveTab('estadisticas')"
              href="#"
            >
              <div class="tab-content-wrapper">
                <div class="tab-icon-text">
                  <i class="nc-icon nc-chart-bar-32"></i>
                  <span class="tab-text d-none d-sm-inline">Estadísticas</span>
                  <span class="tab-text d-sm-none">Est</span>
                </div>
                <div class="tab-badge">
                  <!-- Sin badge para estadísticas -->
                </div>
              </div>
              <!-- Indicador verde para pestaña activa -->
              <div v-if="activeTab === 'estadisticas'" class="tab-active-indicator"></div>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Contenido de las Pestañas -->
    <div class="tab-content">
      
      <!-- PESTAÑA FAMILIAS -->
      <div v-if="activeTab === 'familias'" class="tab-pane active">
        <familias-manager 
          :catalogos="catalogos"
          @actualizarEstadisticas="actualizarEstadisticas"
          @refresh="loadCatalogos"
          @navegarASubFamilias="handleNavegacionSubFamilias"
        />
      </div>

      <!-- PESTAÑA SUBFAMILIAS -->
      <div v-if="activeTab === 'subfamilias'" class="tab-pane active">
        <subfamilias-manager 
          :catalogos="catalogos"
          :familia-preseleccionada="familiaPreseleccionada"
          :contexto-navegacion="contextoNavegacion"
          @actualizarEstadisticas="actualizarEstadisticas"
          @refresh="loadCatalogos"
          @cambiarTab="setActiveTab"
          @navegarAPlanes="handleNavegacionPlanes"
          @limpiarContexto="limpiarContextoNavegacion"
        />
      </div>

      <!-- PESTAÑA PLANES -->
      <div v-if="activeTab === 'planes'" class="tab-pane active">
        <planes-manager 
          :catalogos="catalogos"
          :categoria-preseleccionada="categoriaPreseleccionada"
          @actualizarEstadisticas="actualizarEstadisticas"
          @refresh="loadCatalogos"
          @limpiarCategoria="limpiarCategoriaPreseleccionada"
        />
      </div>



      <!-- PESTAÑA ESTADÍSTICAS -->
      <div v-if="activeTab === 'estadisticas'" class="tab-pane active">
        <estadisticas-dashboard 
          :estadisticas="estadisticas"
          @refresh="onEstadisticasRefresh"
        />
      </div>

    </div>

  </div>
</template>

<script>
import FamiliasManager from './GestionDePlanes/FamiliasManager.vue'
import SubFamiliasManager from './GestionDePlanes/SubFamiliasManager.vue'
import PlanesManager from './GestionDePlanes/PlanesManager.vue'
import EstadisticasDashboard from './GestionDePlanes/EstadisticasDashboard.vue'

export default {
  name: 'GestionDePlanes',
  components: {
    'familias-manager': FamiliasManager,
    'subfamilias-manager': SubFamiliasManager,
    'planes-manager': PlanesManager,
    'estadisticas-dashboard': EstadisticasDashboard
  },
  data() {
    return {
      activeTab: 'familias',
      loading: {
        catalogos: false,
        estadisticas: false
      },
      catalogos: {
        familias: [],
        subfamilias: [],
        unidadesDuracion: [],
        tiposConvenio: [],
        sucursales: []
      },
      estadisticas: {
        totalFamilias: 0,
        totalSubFamilias: 0,
        totalPlanes: 0,
        planesActivos: 0,
        planesInactivos: 0
      },
      familiaPreseleccionada: null,
      categoriaPreseleccionada: null,
      contextoNavegacion: null
    }
  },
  async mounted() {
    await this.initializeComponent()
  },
  methods: {
    async initializeComponent() {
      try {
        console.log('🔄 Inicializando componente de gestión de planes...')
        
        // Cargar datos iniciales en paralelo
        const resultados = await Promise.allSettled([
          this.loadCatalogos(),
          this.loadEstadisticas()
        ])
        
        // Log de resultados de inicialización
        const errores = resultados.filter(r => r.status === 'rejected')
        if (errores.length > 0) {
          console.warn('⚠️ Algunos datos no se pudieron cargar en la inicialización:', errores)
        }
        
        console.log('✅ Inicialización completada')
        
      } catch (error) {
        console.error('❌ Error al inicializar:', error)
        
        // Notificación toast sutil en lugar de modal persistente
        this.$swal.fire({
          title: 'Error al Cargar Datos',
          text: 'Algunos datos no se pudieron cargar. Usa el botón "Actualizar Todo" para reintentar.',
          icon: 'warning',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true
        })
      }
    },

    async loadCatalogos() {
      try {
        this.loading.catalogos = true
        
        console.log('📂 Cargando catálogos...')
        
        const [familiasResult, subfamiliasResult, auxiliaresResult] = await Promise.allSettled([
          this.consultarCatalogoFamilias(),
          this.consultarCatalogoSubFamilias(),
          this.loadCatalogosAuxiliares()
        ])
        
        // Manejar resultados de Promise.allSettled
        this.catalogos.familias = familiasResult.status === 'fulfilled' ? (familiasResult.value || []) : []
        this.catalogos.subfamilias = subfamiliasResult.status === 'fulfilled' ? (subfamiliasResult.value || []) : []
        
        // Log de resultados individuales para debugging
        if (familiasResult.status === 'rejected') {
          console.error('❌ Error al cargar familias:', familiasResult.reason)
        }
        if (subfamiliasResult.status === 'rejected') {
          console.error('❌ Error al cargar subfamilias:', subfamiliasResult.reason)
        }
        if (auxiliaresResult.status === 'rejected') {
          console.error('❌ Error al cargar catálogos auxiliares:', auxiliaresResult.reason)
        }
        
        console.log('✅ Catálogos cargados:', {
          familias: this.catalogos.familias.length,
          subfamilias: this.catalogos.subfamilias.length
        })
        
      } catch (error) {
        console.error('❌ Error al cargar catálogos:', error)
        
        // Notificación toast discreta
        this.$swal.fire({
          title: 'Error al Cargar Catálogos',
          text: 'Los catálogos no se pudieron cargar completamente',
          icon: 'warning',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
          timerProgressBar: true
        })
        
        // Asegurar valores por defecto
        this.catalogos.familias = []
        this.catalogos.subfamilias = []
      } finally {
        // SIEMPRE desactivar loading de catálogos
        this.loading.catalogos = false
      }
    },

    async consultarCatalogoFamilias() {
      try {
        const response = await this.$CentralGymOPS_API({
          method: 'POST',
          url: '/',
          headers: {
            'Authorization': `Bearer ${sessionStorage.getItem('jCxbraoQeD')}`
          },
          data: {
            Header: {
              Operacion: '/v1/planes/familia/catalogo'
            },
            Auth: {
              Token: sessionStorage.getItem('jCxbraoQeD')
            },
            Parameters: {},
            Body: {}
          }
        })

        if (response.data?.dataOut?.familias) {
          return response.data.dataOut.familias
        }
        return []
        
      } catch (error) {
        console.error('Error al consultar catálogo de familias:', error)
        return []
      }
    },

    async consultarCatalogoSubFamilias() {
      try {
        const response = await this.$CentralGymOPS_API({
          method: 'POST',
          url: '/',
          headers: {
            'Authorization': `Bearer ${sessionStorage.getItem('jCxbraoQeD')}`
          },
          data: {
            Header: {
              Operacion: '/v1/planes/subfamilia/catalogo'
            },
            Auth: {
              Token: sessionStorage.getItem('jCxbraoQeD')
            },
            Parameters: {},
            Body: {}
          }
        })

        if (response.data?.dataOut?.subfamilias) {
          return response.data.dataOut.subfamilias
        }
        return []
        
      } catch (error) {
        console.error('Error al consultar catálogo de subfamilias:', error)
        return []
      }
    },

    async loadCatalogosAuxiliares() {
      // Cargar unidades de duración, tipos de convenio, sucursales, etc.
      // Estas serán llamadas a APIs existentes del sistema
      try {
        console.log('📋 Cargando catálogos auxiliares...')
        
        // Placeholder - implementar llamadas reales a catálogos existentes
        this.catalogos.unidadesDuracion = []
        this.catalogos.tiposConvenio = []
        this.catalogos.sucursales = []
        
        console.log('✅ Catálogos auxiliares cargados')
      } catch (error) {
        console.error('❌ Error al cargar catálogos auxiliares:', error)
        
        // Asegurar valores por defecto incluso en caso de error
        this.catalogos.unidadesDuracion = []
        this.catalogos.tiposConvenio = []
        this.catalogos.sucursales = []
      }
    },

    async loadEstadisticas() {
      try {
        this.loading.estadisticas = true
        
        console.log('📊 Cargando estadísticas...')
        
        // Implementar llamada a endpoint de estadísticas cuando esté disponible
        // Por ahora usar datos mock pero preservando valores existentes
        const nuevasEstadisticas = {
          totalFamilias: this.catalogos.familias?.length || this.estadisticas.totalFamilias || 0,
          totalSubFamilias: this.catalogos.subfamilias?.length || this.estadisticas.totalSubFamilias || 0,
          // Preservar totalPlanes existente si ya se había cargado desde PlanesManager
          totalPlanes: this.estadisticas.totalPlanes || 0,
          planesActivos: this.estadisticas.planesActivos || 0,
          planesInactivos: this.estadisticas.planesInactivos || 0
        }
        
        // Usar el método actualizarEstadisticas para hacer un merge en lugar de sobrescribir
        this.actualizarEstadisticas(nuevasEstadisticas)
        
        console.log('✅ Estadísticas actualizadas preservando valores existentes:', this.estadisticas)
        
      } catch (error) {
        console.error('❌ Error al cargar estadísticas:', error)
        
        // En caso de error, asegurar valores mínimos
        if (!this.estadisticas.totalFamilias && !this.estadisticas.totalSubFamilias) {
          this.estadisticas = {
            totalFamilias: 0,
            totalSubFamilias: 0,
            totalPlanes: 0,
            planesActivos: 0,
            planesInactivos: 0
          }
        }
      } finally {
        // SIEMPRE desactivar loading de estadísticas
        this.loading.estadisticas = false
      }
    },

    setActiveTab(tab) {
      console.log(`📊 Cambiando a pestaña: ${tab}`)
      console.log('📊 Estadísticas antes del cambio:', JSON.stringify(this.estadisticas))
      
      this.activeTab = tab
      
      // Limpiar contexto de navegación al cambiar de pestaña manualmente
      if (tab !== 'subfamilias') {
        this.contextoNavegacion = null
      }
      
      // No recargar estadísticas al cambiar de pestaña para preservar los conteos
      console.log('📊 Estadísticas después del cambio:', JSON.stringify(this.estadisticas))
    },

    handleNavegacionSubFamilias(navegacion) {
      console.log('🔄 Recibida navegación a SubFamilias:', navegacion)
      
      // En lugar de preseleccionar, establecer contexto de navegación
      this.contextoNavegacion = {
        origen: 'familias',
        familiaOrigen: {
          id: navegacion.familiaIdNumerico || navegacion.familiaId,
          _id: navegacion.familiaId,
          nombre: navegacion.familiaNombre,
          activo: navegacion.familiaActivo !== undefined ? navegacion.familiaActivo : true
        }
      }
      
      // Limpiar familia preseleccionada para mostrar vista global
      this.familiaPreseleccionada = null
      
      // Cambiar a la pestaña de SubFamilias
      this.setActiveTab('subfamilias')
      
      console.log('✅ Contexto de navegación establecido:', this.contextoNavegacion)
    },

    handleNavegacionPlanes(navegacion) {
      console.log('🔄 Recibida navegación a Planes:', navegacion)
      
      // Establecer la categoría preseleccionada (familia + subfamilia)
      this.categoriaPreseleccionada = {
        familiaId: navegacion.familiaIdNumerico || navegacion.familiaId,    // ID numérico para filtros
        familia_id: navegacion.familiaId,                                   // MongoDB _id
        familiaNombre: navegacion.familiaNombre,
        subfamiliaId: navegacion.subfamiliaIdNumerico || navegacion.subfamiliaId,  // ID numérico para filtros
        subfamilia_id: navegacion.subfamiliaId,                             // MongoDB _id
        subfamiliaNombre: navegacion.subfamiliaNombre
      }
      
      // Cambiar a la pestaña de Planes
      this.setActiveTab('planes')
      
      console.log('✅ Categoría preseleccionada para planes:', this.categoriaPreseleccionada)
    },

    async refreshAll() {
      // Modal de carga eliminado - el componente usa spinners internos
      console.log('🔄 Actualizando toda la información...')
      
      try {
        // Usar Promise.allSettled para manejo robusto de errores
        const resultados = await Promise.allSettled([
          this.loadCatalogos(),
          this.loadEstadisticas()
        ])
        
        // Verificar si alguna operación falló
        const errores = resultados.filter(r => r.status === 'rejected')
        
        if (errores.length > 0) {
          console.warn('⚠️ Algunas operaciones fallaron:', errores)
          
          this.$swal.fire({
            title: 'Actualización Parcial',
            text: 'Se actualizó la información disponible, pero algunos datos podrían no estar completos',
            icon: 'warning',
            showConfirmButton: true,
            confirmButtonText: 'Entendido',
            confirmButtonClass: 'btn btn-warning',
            timer: 3000,
            timerProgressBar: true
          })
        } else {
          console.log('✅ Actualización completa exitosa')
          
          this.$swal.fire({
            title: '¡Actualizado!',
            text: 'Toda la información ha sido refrescada exitosamente',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            toast: true,
            position: 'top-end'
          })
        }
        
      } catch (error) {
        console.error('❌ Error al refrescar:', error)
        this.$swal.fire({
          title: 'Error',
          text: 'No se pudo actualizar la información. Por favor, inténtalo nuevamente.',
          icon: 'error',
          confirmButtonText: 'Entendido',
          confirmButtonClass: 'btn btn-danger',
          timer: 4000,
          timerProgressBar: true
        })
      }
    },

    actualizarEstadisticas(nuevasEstadisticas) {
      console.log('📊 Actualizando estadísticas:')
      console.log('  - Estadísticas anteriores:', JSON.stringify(this.estadisticas))
      console.log('  - Nuevas estadísticas:', JSON.stringify(nuevasEstadisticas))
      
      this.estadisticas = { ...this.estadisticas, ...nuevasEstadisticas }
      
      console.log('  - Estadísticas resultantes:', JSON.stringify(this.estadisticas))
    },

    limpiarCategoriaPreseleccionada() {
      console.log('🧹 Limpiando categoría preseleccionada')
      this.categoriaPreseleccionada = null
    },

    limpiarContextoNavegacion() {
      console.log('🧹 Limpiando contexto de navegación')
      this.contextoNavegacion = null
    },

    onEstadisticasRefresh() {
      // No recargar las estadísticas básicas cuando se actualiza el dashboard de estadísticas
      // Las estadísticas de conteo (totalFamilias, totalSubFamilias, totalPlanes) 
      // deben mantenerse tal como están ya que provienen de los datos cargados
      console.log('📊 Dashboard de estadísticas refrescado - manteniendo conteos existentes:', this.estadisticas)
      
      // Opcional: Solo actualizar si algunos valores están en 0 o undefined
      if (!this.estadisticas.totalFamilias) {
        this.estadisticas.totalFamilias = this.catalogos.familias?.length || 0
      }
      if (!this.estadisticas.totalSubFamilias) {
        this.estadisticas.totalSubFamilias = this.catalogos.subfamilias?.length || 0
      }
      
      console.log('📊 Estadísticas después de verificación:', this.estadisticas)
    },

    /* 
    // FUNCIONES DE EMERGENCIA COMENTADAS - USADAS PARA DEBUGGING DEL PROBLEMA DE MODAL PERSISTENTE
    // Estas funciones fueron implementadas para resolver el problema de modales de carga que no desaparecían
    // Una vez resuelto el problema, se mantienen comentadas para futuras referencias si es necesario

    // Método de emergencia para forzar la desactivación del loading
    forceStopLoading(razon = 'Forzado manualmente') {
      console.warn('🚨 FORCE STOP LOADING - Razón:', razon)
      // ... código comentado para debugging ...
    },

    // Método agresivo para remover TODOS los modales de loading del DOM
    forceRemoveAllLoadingModals() {
      console.warn('🔥 MÉTODO AGRESIVO: Removiendo todos los modales de loading del DOM')
      // ... código comentado para debugging ...
    }
    */
  }
}
</script>

<style scoped>
.gestion-planes-container {
  min-height: 100vh;
  background-color: #f4f5f7;
  padding: 20px;
}

.content-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 15px;
  padding: 25px;
  color: white;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
}

.content-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
}

.content-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  margin-bottom: 0;
}

/* Contenedor principal de pestañas - Centrado en desktop/tablet */
.nav-tabs-container {
  display: flex;
  justify-content: center;
}

.nav-tabs-wrapper {
  background: white;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 4px 20px 0 rgba(0,0,0,0.1);
  max-width: 800px; /* Ancho máximo para desktop */
  width: 100%;
}

.nav-tabs {
  border: none;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 8px;
}

.nav-tabs .nav-item {
  flex: 1; /* Todos los elementos del mismo tamaño */
}

.nav-tabs .nav-link {
  border: none;
  border-radius: 6px;
  color: #6c757d;
  font-weight: 600;
  padding: 12px 8px;
  margin: 0 2px;
  transition: all 0.3s ease;
  background: transparent;
  text-align: center;
  height: auto;
  min-height: 50px; /* Altura mínima uniforme - más compacto */
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-tabs .nav-link:hover {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
  transform: translateY(-2px);
}

.nav-tabs .nav-link.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 15px 0 rgba(102, 126, 234, 0.4);
}

/* Estructura del contenido de cada pestaña */
.tab-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.tab-icon-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  gap: 6px;
}

.tab-icon-text i {
  font-size: 1.1rem;
  margin-bottom: 0;
  margin-right: 0;
  display: inline-block;
  flex-shrink: 0;
}

.tab-text {
  font-size: 0.9rem;
  line-height: 1.2;
}

.tab-badge {
  min-height: 20px; /* Espacio reservado para el badge */
  display: flex;
  align-items: center;
  justify-content: center;
  /* Asegurar que siempre ocupe el espacio incluso sin contenido */
  flex-shrink: 0;
}

.tab-badge .badge {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 2px 6px;
}

.tab-content {
  background: white;
  border-radius: 12px;
  min-height: 500px;
  box-shadow: 0 4px 20px 0 rgba(0,0,0,0.1);
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

/* Responsive Design */

/* Tablet (768px - 991px) */
@media (max-width: 991px) and (min-width: 769px) {
  .nav-tabs-wrapper {
    max-width: 700px;
    padding: 12px;
  }
  
  .nav-tabs .nav-link {
    min-height: 45px;
    padding: 8px 6px;
  }
  
  .tab-icon-text i {
    font-size: 1rem;
  }
  
  .tab-text {
    font-size: 0.85rem;
  }
  
  /* Indicador verde para tablet */
  .tab-active-indicator {
    width: 10px;
    height: 10px;
    top: 5px;
    right: 6px;
  }
}

/* Mobile (up to 768px) */
@media (max-width: 768px) {
  .gestion-planes-container {
    padding: 10px;
  }
  
  .content-header {
    padding: 20px 15px;
    text-align: center;
  }
  
  .content-title {
    font-size: 1.5rem;
  }
  
  .content-subtitle {
    font-size: 1rem;
  }
  
  /* Pestañas en móvil - ancho completo */
  .nav-tabs-container {
    justify-content: stretch;
  }
  
  .nav-tabs-wrapper {
    max-width: none;
    width: 100%;
    padding: 10px;
    margin: 0;
  }
  
  .nav-tabs {
    padding: 6px;
  }
  
  .nav-tabs .nav-link {
    min-height: 42px;
    padding: 6px 4px;
    margin: 0 1px;
    font-size: 0.8rem;
  }
  
  .tab-icon-text i {
    font-size: 0.9rem;
    margin-bottom: 0;
  }
  
  .tab-text {
    font-size: 0.75rem;
    line-height: 1.1;
  }
  
  .tab-icon-text {
    gap: 4px;
  }
  
  .tab-badge .badge {
    font-size: 0.65rem;
    padding: 1px 4px;
  }
  
  /* Indicador verde para móviles */
  .tab-active-indicator {
    width: 9px;
    height: 9px;
    top: 4px;
    right: 5px;
  }
}

/* Small Mobile (up to 576px) */
@media (max-width: 576px) {
  .nav-tabs-wrapper {
    padding: 8px;
  }
  
  .nav-tabs {
    padding: 4px;
  }
  
  .nav-tabs .nav-link {
    min-height: 38px;
    padding: 5px 2px;
    margin: 0;
  }
  
  .tab-icon-text i {
    font-size: 0.85rem;
    margin-bottom: 0;
  }
  
  .tab-text {
    font-size: 0.7rem;
  }
  
  .tab-icon-text {
    gap: 3px;
  }
  
  .tab-badge .badge {
    font-size: 0.6rem;
    padding: 1px 3px;
  }
  
  /* Indicador verde para móviles pequeños */
  .tab-active-indicator {
    width: 8px;
    height: 8px;
    top: 3px;
    right: 4px;
  }
}

/* Extra Small Mobile (up to 480px) */
@media (max-width: 480px) {
  .nav-tabs .nav-link {
    min-height: 35px;
    padding: 4px 1px;
  }
  
  .tab-icon-text i {
    font-size: 0.75rem;
  }
  
  .tab-text {
    font-size: 0.65rem;
  }
  
  .tab-icon-text {
    gap: 2px;
  }
  
  .tab-badge .badge {
    font-size: 0.55rem;
    padding: 1px 2px;
  }
  
  /* Indicador verde más pequeño en móviles extra pequeños */
  .tab-active-indicator {
    width: 7px;
    height: 7px;
    top: 2px;
    right: 3px;
    border-width: 1px;
  }
}

/* Animaciones */
.tab-pane {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Efectos hover mejorados */
.nav-tabs .nav-link {
  position: relative;
  overflow: hidden;
}

.nav-tabs .nav-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.nav-tabs .nav-link:hover::before {
  left: 100%;
}

/* Mejoras adicionales para la experiencia del usuario - Estilos ya incluidos arriba */

.nav-tabs .nav-link:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.3);
}

/* Animación suave para cambios de tamaño */
.tab-content-wrapper,
.tab-icon-text,
.tab-badge {
  transition: all 0.3s ease;
}

/* Mejora para badges cuando no hay datos */
.tab-badge:empty {
  min-height: 20px;
}

/* Asegurar que todos los tabs tengan el mismo ancho en todas las pantallas */
@media (min-width: 992px) {
  .nav-tabs-wrapper {
    max-width: 900px; /* Más ancho en pantallas grandes */
  }
  
  .nav-tabs .nav-link {
    min-height: 52px;
    padding: 12px 10px;
  }
  
  .tab-icon-text i {
    font-size: 1.1rem;
    margin-bottom: 0;
  }
  
  .tab-text {
    font-size: 1rem;
  }
  
  .tab-badge .badge {
    font-size: 0.75rem;
    padding: 3px 8px;
  }
  
  /* Indicador verde para desktop */
  .tab-active-indicator {
    width: 12px;
    height: 12px;
    top: 6px;
    right: 8px;
  }
}

/* Hover mejorado para dispositivos táctiles */
@media (hover: hover) {
  .nav-tabs .nav-link:hover .tab-icon-text i {
    transform: scale(1.1);
  }
  
  .nav-tabs .nav-link:hover .tab-badge .badge {
    transform: scale(1.05);
  }
}

/* Estados activos mejorados */
.nav-tabs .nav-link.active .tab-icon-text i {
  text-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

.nav-tabs .nav-link.active .tab-badge .badge {
  background-color: rgba(255,255,255,0.2) !important;
  color: white !important;
  border: 1px solid rgba(255,255,255,0.3);
}

/* Indicador verde para pestaña activa */
.tab-active-indicator {
  position: absolute;
  top: 5px;
  right: 6px;
  width: 10px;
  height: 10px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(40, 167, 69, 0.4);
  z-index: 10;
  animation: pulseGreen 2s infinite;
}

/* Animación del punto verde */
@keyframes pulseGreen {
  0% {
    transform: scale(1);
    box-shadow: 0 2px 6px rgba(40, 167, 69, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.6);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 2px 6px rgba(40, 167, 69, 0.4);
  }
}

/* Asegurar posición relativa en nav-link para el indicador absoluto */
.nav-tabs .nav-link {
  position: relative;
  cursor: pointer;
  user-select: none;
}

/* Asegurar visualización de íconos en pestañas */
.nav-tabs .nav-link .nc-icon {
  display: inline-block;
  color: inherit;
}

/* Ocultar cualquier flecha de Bootstrap o indicadores triangulares */
.nav-tabs .nav-link::after,
.nav-tabs .nav-link::before {
  display: none !important;
}

.nav-tabs .nav-link.active::after,
.nav-tabs .nav-link.active::before {
  display: none !important;
}
</style> 